import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { EleicaoService } from 'src/app/services/eleicao.service'
import { BlacklistService } from 'src/app/services/blacklist.service'
import { Blacklist } from 'src/app/models/blacklist.model'
import { BlacklistCsvDTO } from 'src/app/models/blacklistCsvDTO.model';
import { Utils } from 'src/app/utils/utils';

@Component({
  selector: 'cadastro-massa-blacklist',
  templateUrl: './blacklist-csv-import.component.html',
  styleUrls: ['./blacklist-csv-import.component.css']
})
export class BlacklistCsvComponent implements OnInit {
  public newBlacklistArray: BlacklistCsvDTO[] = [];

  formCadastroBlacklists: FormGroup;
  idEleicao: any;
  token: any;
  listaBlacklist: any;
  novoLoginBlacklist: any;
  newBlacklistDTO: BlacklistCsvDTO = new BlacklistCsvDTO();

  constructor(
    public eleicaoService: EleicaoService,
    public blacklistService: BlacklistService,
    public utils: Utils,
    protected messageService: MessageService
  ) { }

  async ngOnInit() {
    this.novoLoginBlacklist = new Blacklist();
    this.idEleicao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao")).id;
    this.token = sessionStorage.getItem("token");
    this.formCadastroBlacklists = new FormGroup({
      login: new FormControl()
    })
  }


  // CSV
  importarCsv(event) {

    let arquivos = event.srcElement.files;

    if (this.validaTipoArquivo(arquivos[0])) {
      let input = event.target;
      let fileReader = new FileReader();
      fileReader.readAsText(input.files[0]);

      fileReader.onload = () => {
        let csvData = fileReader.result;
        let csvRecordsArray = csvData.toString().split(/\r\n|\n/);
        let headersRow = this.utils.getHeaderArray(csvRecordsArray);
        this.newBlacklistArray = this.getDataRecordsArrayFromCSVFile(csvRecordsArray, headersRow.length, this.idEleicao);
      };
    }
  }

  validaTipoArquivo(file: any) {
    return file.name.endsWith(".csv");
  }

  getDataRecordsArrayFromCSVFile(csvRecordsArray: any, headerLength: any, eleicaoId: number) {
    let csvArr = [];

    for (let i = 1; i < csvRecordsArray.length; i++) {
      let currentRecord = csvRecordsArray[i];
      if (currentRecord.length != 0) {
        let csv: BlacklistCsvDTO = new BlacklistCsvDTO();
        csv.login = currentRecord;
        csv.eleicaoId = eleicaoId;
        csvArr.push(csv);
      }
    }
    return csvArr
  }
  private async insercaoEmMassa(blacklist: BlacklistCsvDTO[]) {
    await this.blacklistService.inserirLoginsNaBlackListEmMassa(this.token, blacklist).then(() => {
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Blacklist enviada com sucesso!' });
      setTimeout(function () {
        window.location.reload();
      })
    }, err => {
      this.messageService.add({ key: 'toast', severity: 'error', summary: '', detail: 'Houve um erro ao enviar a blacklist selecionada, tente novamente!' });
    });
  }

  zerarInputFile(element){
    this.newBlacklistArray = [];
     element.value = '';
  }
  importarList(){
    this.insercaoEmMassa(this.newBlacklistArray);
  }
}
